export enum SedsSnackbarButtonAction {
  OK = 'OK',
  CLOSE = 'close',
}
